import {
  useApiQuery,
  useApiMutation,
  useInfiniteApiQuery,
} from "lib/react-query";
import { API_BASE_KEYS } from "services/api";

const CENTRAL_OPTIONS = { baseUrl: API_BASE_KEYS.CENTRAL };
const BASE = "account/core-support";

/**
 * Paginated tickets list for the current tenant.
 * Filters are passed as `otherParam` (not `hasSearchParams`) because the shared
 * search-state helper treats `type` as a presentational param and would drop it.
 */
export const useAmerSupportList = (page, filters) =>
  useApiQuery(BASE, page, false, filters, CENTRAL_OPTIONS);

/** Ticket counts across all statuses (for the stat cards). */
export const useAmerSupportStats = () =>
  useApiQuery(`${BASE}/stats`, null, false, null, CENTRAL_OPTIONS);

/** Single ticket detail. */
export const useAmerSupportTicket = (id) =>
  useApiQuery(id ? `${BASE}/${id}` : null, null, false, null, CENTRAL_OPTIONS);

/** Paginated (newest-first) reply thread — "load more" older replies. */
export const useAmerSupportReplies = (id) =>
  useInfiniteApiQuery(id ? `${BASE}/${id}/replies` : null, {
    perPage: 10,
    fetchOptions: CENTRAL_OPTIONS,
  });

/** Count of tickets that received a reply and need the tenant's action (top bar). */
export const useAmerSupportNeedsActionCount = (extraOptions = {}) =>
  useApiQuery(
    `${BASE}/needs-action-count`,
    null,
    false,
    null,
    CENTRAL_OPTIONS,
    extraOptions
  );

/** create (ticket), sendReply, close — all against the central base. */
export const useAmerSupportMutation = (callbacks = {}) =>
  useApiMutation({ ...callbacks, fetchOptions: CENTRAL_OPTIONS });

export { BASE as AMER_SUPPORT_BASE };
